import React from "react";
import { Wrapper, Title } from "./style";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";
import Loading from "src/components/Loading";
import { getSection } from "src/hooks/useContentful/getSection";
import Steps from "./Steps";

export default function ComoFunciona() {
	const { data, isLoading } = useFetchContent();

	if (isLoading || !data) return <Loading />;

	const { title } = getSection({
		sectionName: "landingStepperSection",
		data,
	});

	return (
    <Wrapper backgroundColor={'#EDEDED'}>
      <Title tamanho="Médio">{title}</Title>
      <Steps />
    </Wrapper>
	);
}
